<script lang="ts" setup>
    import { computed } from 'vue';
    import { NodeType, NodeTaskVariation } from '@journeys/Enums';
    import { JourneyNode, UngappedJourney } from '@journeys/Journeys.viewmodel';

    const { activeJourney } = defineProps<{
        activeJourney: UngappedJourney;
        stepList: any[] | null;
    }>();

    const countNumberOfIssues = computed(() => {
        return Object.values(activeJourney.steps).filter((step: any) => {
            const node = activeJourney.nodes[step.nodeId] as JourneyNode;
            return node?.data.type === NodeType.Task && node.data.var === NodeTaskVariation.Email;
        }).length;
    });

    const countNumberOfTextMessages = computed(() => {
        return Object.values(activeJourney.steps).filter((step: any) => {
            const node = activeJourney.nodes[step.nodeId] as JourneyNode;
            return node?.data.type === NodeType.Task && node.data.var === NodeTaskVariation.Sms;
        }).length;
    });
</script>

<template>
    <template v-if="stepList && stepList.length > 0">
        <div class="d-flex flex-wrap col-gap-lg m-lg-b strong">
            <div class="d-flex col-gap-xs align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--brand-primary-500)">
                    <path
                        d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
                </svg>
                {{ countNumberOfIssues }} {{ $Resources.JourneyEmailsTotalLabel }}
            </div>
            <div class="d-flex col-gap-xs align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--brand-primary-500)">
                    <path
                        d="M320-520q17 0 28.5-11.5T360-560q0-17-11.5-28.5T320-600q-17 0-28.5 11.5T280-560q0 17 11.5 28.5T320-520Zm160 0q17 0 28.5-11.5T520-560q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560q0 17 11.5 28.5T480-520Zm160 0q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
                </svg>
                {{ countNumberOfTextMessages }} {{ $Resources.JourneyTextMessagesTotalLabel }}
            </div>
        </div>
    </template>
</template>
